import { createContext } from "react";

// NOTE: NSAI-7067 — state the transfer popup keeps across pages. Dismissals and
// the "a composer is on screen" registry live above the routes so that moving
// from a chat to the meeting list neither resurrects a card the user closed
// nor leaves two cards on screen at once.
export interface ITransferPopupContext {
  // NOTE: Entries the popup has let go of — dismissed by hand, or finished
  // uploads whose linger ran out. Popup-only: the Uploads page keeps its rows.
  hiddenIds: ReadonlySet<string>;
  hideEntries: (entryIds: string[]) => void;
  // NOTE: How many chat composers are mounted and offering a dock above
  // themselves. While at least one is, the popup docks there (Pavel's
  // placement in NSAI-5939: above the text field, so it never covers the
  // composer's controls); otherwise it floats in the bottom corner. A count,
  // not a boolean: during a navigation the incoming page can register before
  // the outgoing one has cleaned up.
  dockCount: number;
  registerDock: () => () => void;
}

export const TransferPopupContext = createContext<ITransferPopupContext | null>(
  null,
);
